import styled from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';

export const StyledTextarea = styled.textarea`
  border-radius: 6px;
  border: 1px solid ${({ failed }) => failed ? colors.theme.danger : colors.theme.primary_light};
  width: 100%;
  padding: 18px 10px 10px 10px;
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: -0.27px;
  color: #636262;
  resize: none;
  height: ${({ height }) => height+'px' || 'auto'};

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
    border-radius: 20px;
    margin: 5px 5px;
  }

  ::-webkit-scrollbar-thumb {
    //height: 6px;
    border: 2px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color: ${colors.elements.primary};
    //-webkit-box-shadow: inset -1px -1px 0px rgb(4, 16, 64), inset 1px 1px 0px rgb(25, 75, 231);
  }

  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  
  &::placeholder {
    opacity: 0.3;
    font-family: ${fontFamily.primary};
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: -0.27px;
    color: #636262;
  }

  // &::-webkit-scrollbar-thumb {
    //    background-color: ${colors.elements.primary};
    //    outline: ${colors.elements.primary};
  //   border-right: 4px transparent solid;
  //   background-clip: padding-box;
  // }
`;
